import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useAtomValue } from "jotai";
import React from "react";

import { logout } from "../auth";
import { userAtom } from "../store";

export const UserPage = () => {
  const user = useAtomValue(userAtom);

  return (
    <Stack>
      <pre>{JSON.stringify(user, null, 2)}</pre>
      <Button onClick={logout}>Logout</Button>
    </Stack>
  );
};
